import React from 'react';
import { Form, Checkbox, DatePicker, Select, Spin } from 'antd';
import { Message } from 'semantic-ui-react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Icon } from 'semantic-ui-react';

import AddEditStore from './store';
import { formatDate } from '../../../utils/functions';
import moment from 'moment';

@observer
class FundingArrangement extends React.Component {
  handleUpload = event => {
    const files = event.target.files;
    if (!files || !files.length) return;

    AddEditStore.handleUploadFile(files[0])
  };
  handleDownloadFile = pathName => {
    window.open(
      `${window.location.origin}/UserFile/ClientAttachment/${pathName}`,
      '_blank',
    );
  };
  checkIsJSON = value => {
    try {
      JSON.parse(value);
    } catch (e) {
      return false;
    }
    return true;
  };
  convertDate = dateString => {
    if (dateString) {
      if (typeof dateString === 'string') {
        if (dateString.search('/Date') !== -1) {
          const dateFormat = formatDate(dateString);
          return moment(dateFormat, 'DD MMM,YYYY');
        }
      } else {
        return moment(dateString, 'DD/MM/YYYY');
      }
    }
    return null;
  };
  render() {
    const data = toJS(AddEditStore.clientInfo);
    const attachments = this.checkIsJSON(data.FAAttachments)
      ? JSON.parse(data.FAAttachments)
      : null;
    const { staffList } = AddEditStore;
    return (
      <Form name="funding-arrangement-form">
        <div className="fluid-field" style={{ marginBottom: '1.5em' }}>
          <Checkbox
            checked={toJS(data.IsFAPaymentRequired)}
            onChange={AddEditStore.handleChecked('IsFAPaymentRequired')}
          >
            Advanced Payment Required
            <i className="blue icon info circle" aria-hidden={true}
            title="Full payment is required prior releasing report to Client"></i>
          </Checkbox>
        </div>
        <Form.Item label="Approval Date">
          <DatePicker
            size="large"
            value={this.convertDate(data.FAApprovedDate)}
            format="DD/MM/YYYY"
            onChange={AddEditStore.handleFieldChange('FAApprovedDate')}
          />
        </Form.Item>
        <Form.Item label="Approved By">
          <Select
            size="large"
            value={data.FAApprovedById}
            onChange={AddEditStore.handleFieldChange('FAApprovedById')}
          >
            {staffList &&
              this.checkIsJSON(staffList) &&
              JSON.parse(staffList).itemList.map(i => (
                <Select.Option key={i.id} value={i.id}>
                  {i.fullName}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item label="Attached Documents" className="fluid-field">
          {(!attachments || attachments.length === 0) ? (
            <Message className="upload-box">
              <div className="upload-file">
                {AddEditStore.uploadLoading && <Spin />}
                <input type="file" onChange={this.handleUpload} />
                Click here to upload
              </div>
            </Message>
          ) : (
            attachments.map((attachment, idx) => (
              <Message className="upload-box" key={idx}>
                <div className="file-info">
                  <div className="file-info-inner">
                    <Icon name="file alternate" />
                    <div className="file-name">{attachment.Title}</div>
                  </div>
                  <div className="file-actions">
                    <Icon
                      name="download"
                      onClick={() =>
                        this.handleDownloadFile(attachment.FileName)
                      }
                    />
                    <Icon
                      name="delete"
                      color="red"
                      onClick={() => AddEditStore.handleDeleteFile(idx)}
                    />
                  </div>
                </div>
              </Message>
            ))
          )}
        </Form.Item>
      </Form>
    );
  }
}

export default FundingArrangement;
